import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimalTypeEnum } from '@api/types/AnimalTypeEnum';
import PriceInfo from '@pages/order/price-info/PriceInfo';
import AnimalInfo from '@pages/order/animal-info/AnimalInfo';
import SurgeryInfo from '@pages/order/surgery-info/SurgeryInfo';
import Patterns from '@pages/order/patterns/Patterns';
import CollarType from '@pages/order/collar-type/CollarType';
import CustomerInfo from '@pages/order/customer-info/CustomerInfo';
import CustomerAddress from '@pages/order/customer-address/CustomerAddress';
import PaymentShipping from '@pages/order/payment-shipping/PaymentShipping';
import MessageDiscount from '@pages/order/message-discount/MessageDiscount';
import Footer from '@pages/order/footer/Footer';



interface OrderFormProps {
	goToSummary: () => void,
}


const OrderForm = (props: OrderFormProps) => {
	const { goToSummary } = props;
	const { t } = useTranslation('forms');

	const formRef = useRef<HTMLDivElement>(null);

	
	const scrollToTop = useCallback(() => {
		formRef?.current?.scrollIntoView({ behavior: 'smooth' });
	},[ formRef ]);

	
	return (
		<div className='order-form' ref={formRef}>

			<h1>{t('dogs.header')}</h1>

			<div className='intro-text'>
				<p>{t('dogs.introText')}</p>
			</div>

			<PriceInfo />

			<h2>{t('dogs.title')}</h2>

			<AnimalInfo />

			<SurgeryInfo />

			<Patterns animalType={AnimalTypeEnum.dog} />

			<CollarType />

			<CustomerInfo />

			<CustomerAddress />

			<PaymentShipping />

			<MessageDiscount />

			<Footer scrollToTop={scrollToTop} goToSummary={goToSummary} />

		</div>
	);
};

export default OrderForm;